import config from "@/config"
import http from "@/utils/request"


export default {
	add: {
		url: `${config.API_URL}/addEventPush/`,
		name: "添加转发规则",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/deleteEventPush/`,
		name: "删除转发规则",
		delete: async function(data){
			return await http.delete(this.url, data);
		}
	},
    list: {
		url: `${config.API_URL}/queryEventPush/`,
		name: "查询转发规则列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    update: {
		url: `${config.API_URL}/updateEventPush/`,
		name: "修改转发规则",
		patch: async function(data){
			return await http.patch(this.url, data);
		}
	},
	all:{
		url: `${config.API_URL}/getPushType/`,
		name: "查询所有推送协议",
		get: async function(data){
			return await http.get(this.url, data);
		}
	}
}
